import React, { FC } from 'react';

import { Stack } from '../../Stack';


export interface ButtonsContainerProps {
    withBackground?: boolean;
}

export const ButtonsContainer: FC<ButtonsContainerProps> = ({ withBackground, children }) => (
    <Stack
        direction='row'
        spacing={3}
        {...withBackground ? {
            p: 4,
            boxShadow: '0px -2px 24px rgba(0, 0, 0, 0.05), 0px -2px 8px rgba(0, 0, 0, 0.05)',
            borderRadius: ({ spacing }) => `0 0 ${spacing(4)} ${spacing(4)}`,
            zIndex: 1,
        } : {
            p: 2,
        }}
    >
        {children}
    </Stack>
);
